export const breakpoints = [
  {
    identifier: 'xs',
    min: 0,
    max: 480
  },
  {
    identifier: 's',
    min: 481,
    max: 767
  },
  {
    identifier: 'm',
    min: 768,
    max: 989
  },
  {
    identifier: 'l',
    min: 990,
    max: 1169
  },
  {
    identifier: 'xl',
    min: 1170,
    max: 1920
  },
  {
    identifier: 'xxl',
    min: 1921,
    max: null
  }
];
